module.exports = __webpack_public_path__ + "static/img/logo2.d2491df.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo2.png
// module id = jUlf
// module chunks = 1